// eslint-disable-next-line no-restricted-imports
import { OrderCommonExpiryTypeEnum } from '@eih-netbroker/api-order';

export const ExpiryType = OrderCommonExpiryTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ExpiryType = (typeof ExpiryType)[keyof typeof ExpiryType];
